import { styled } from 'linaria/react';
import { breakpoints } from 'common/styles/breakpoints';

export const StmSectionContainer = styled.div`
  margin-top: 30px;
  ${breakpoints.only.mobile} {
    align-items: center;
    margin-right: 2px;
    margin-left: 2px;
  }
`;
